var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Materiais',{attrs:{"segmento":0}}),_c('br'),_c('Uniforme'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }